import { AdjustmentType } from 'enums';
import { InvoiceDetail } from 'types';

export default function useAdjustmentQuantity(adjustments: InvoiceDetail[]) {
    return (type: AdjustmentType) => {
        return adjustments.filter((adjustment) => adjustment.adjustmentTypeId === type)
            .reduce((sum, adjustment) => sum + adjustment.quantity, 0) || 0;
    }
}